import React from "react";
import { Link } from "react-router-dom";
const Header = () => {
    return (
        <header className="header space-pt--30 space-pb--30">
            <div className="container">
                    {/* <div className="col-6">
                        <div className="logo space-mb--35">
                            <Link to={process.env.PUBLIC_URL + "/"}>
                                <img
                                    src={
                                        process.env.PUBLIC_URL + ""
                                    }
                                    className="img-fluid"
                                    alt=""
                                />
                            </Link>
                        </div>
                    </div> */}
                    <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <Link  className="navbar-brand" to={process.env.PUBLIC_URL + "/"}>123 Meetings</Link>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav ml-auto">
      <li className="nav-item active">
      <Link  className="nav-link" to={process.env.PUBLIC_URL + "/"}>Join</Link>
      </li>
      <li className="nav-item">
      <Link  className="nav-link" to={process.env.PUBLIC_URL + "/create-meeting"}>Create Meeting</Link>
      </li>
      <li className="nav-item">
      <Link  className="nav-link" to={process.env.PUBLIC_URL + "/create-meeting"}>Settings</Link>
      </li>
  </ul>
   
  </div>
</nav>
                </div>

        </header>
    );
}

export default Header;